export const useFileUploaderStore = defineStore('fileUploader', {
  state: () => ({
    acceptedFiles: [
      'csv',
      'xlsx',
      'pdf',
      'doc',
      'docx',
      'txt',
      'zip',
    ],
    ballotTypes: '',
    boxFolder: null as any,
    complete: false,
    dialog: false,
    electionId: null as any,
    headerText: '',
    limit: 10,
    loading: false,
    onUpdatedFiles: async (_value: any, _request: any) => {},
    orderId: null as any,
    processing: false,
    request: {} as any,
    useInbox: false,
  }),
  getters: {},
  actions: {
    async reset() {
      this.$reset()
    },
    async setFileUploader(options: any) {
      this.$patch({
        dialog: true,
        ...options,
      })
    },
    async updatedFiles(value: any) {
      this.onUpdatedFiles(value, this.request)
    },
  },
})
